<template>
  <section data-layout="error">
    <main>
      <RouterView />
    </main>
  </section>
</template>

<script setup lang="ts"></script>
